export const getURLSearchParams = (locationSearch: string) => {
  const result: any = {};
  new URLSearchParams(locationSearch).forEach((v, k) => {
    result[k] = v;
  });
  return result;
};

export function _objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const _jsonToMap = (jsonStr: string) => {
  return _objToStrMap(JSON.parse(jsonStr));
};

export const getUrlParams = (key: string) => {
  var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

export const randomString = function (length) {
  const possible =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let text = '';
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};



export function formatWithCommas(input) {
  if (!input) {
    return input;
  } else {
    let number = Number(input);

    // Convert number to string
    let numStr = number.toString();

    // Split the string into integer part and decimal part
    let parts = numStr.split('.');
    let integerPart = parts[0];
    let decimalPart = parts.length > 1 ? '.' + parts[1] : '';

    // Add commas to integer part
    let formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Combine integer part and decimal part
    let formattedNumber = formattedIntegerPart + decimalPart;

    return formattedNumber;
  }
}

export const roundToTwoDecimals = (input) => {
  if (!input) {
    return input;
  } else {
    const number = Number(input);
    if (Number.isFinite(number) && !Number.isInteger(number)) {
      return formatWithCommas(Math.round(number * 100) / 100);
    } else {
      return formatWithCommas(number);
    }
  }
};


export const roundToWholeNumber = (input) => {
  if (!input) {
    return input;
  } else {
    const number = Number(input);
    if (Number.isFinite(number) && !Number.isInteger(number)) {
      return formatWithCommas(Math.round(number));
    } else {
      return formatWithCommas(number);
    }
  }
};

export function roundFun(value, n) {
    return Math.round(value * Math.pow(10,n)) / Math.pow(10,n);
}

export function formatCostAvg(totalCost, divisor, unitMillion=false){
  if(totalCost === undefined || totalCost === null || totalCost === ''){
    return ""
  }else if(totalCost === 0){
    return 0  + (unitMillion ? 'M' : 'K');
  } else {
    let avg;
    if (unitMillion) {
      avg = Math.ceil(totalCost / divisor *1000000); 
      return '$' + formatWithCommas(roundFun(avg / 1000000,2)) + 'M';
    } else {
      avg = Math.ceil(totalCost / divisor * 1000); // Divide by 1000
      return '$' + formatWithCommas(roundFun(avg / 1000, 2)) + 'K';
    }
 }
}

export function getMaxYAxisValue(data, visitProperty) {
  return Math.max(...data.map(entry => entry[visitProperty]));
}

export function calculateMaxValue(data,visitProperty,firstVisitValue,subsequentVisitsValue, numberOfTicks =5) {
  let maxYChartValue;
  let tickValue;

  if (data !== null) {
      const maxDctPatientBurden = getMaxYAxisValue(data, visitProperty);
      if (firstVisitValue > maxDctPatientBurden || subsequentVisitsValue > maxDctPatientBurden) {
          const maxValue = firstVisitValue > subsequentVisitsValue ? firstVisitValue : subsequentVisitsValue;
          tickValue = Math.ceil(maxValue / numberOfTicks);
          maxYChartValue = Math.ceil(maxValue / tickValue) * tickValue;
      } else {
          tickValue = Math.ceil(maxDctPatientBurden / numberOfTicks);
          maxYChartValue = Math.ceil(maxDctPatientBurden / tickValue) * tickValue;
      }
  } else if (data=== null && firstVisitValue !== null && subsequentVisitsValue !== null) {
      const maxValue = firstVisitValue > subsequentVisitsValue ? firstVisitValue : subsequentVisitsValue;
      tickValue = Math.ceil(maxValue / numberOfTicks);
      maxYChartValue = Math.ceil(maxValue / tickValue) * tickValue;
  } else {
      maxYChartValue = 0;
  }

  return { maxYChartValue, tickValue };
}

export function getPageForKey(key) {
        return key.split('-')[0];
      }



export function toSentenceCase(str) {
  if (!str) {
    return str;
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  
}

export function missingYearsFill(activity) { 
  if(activity['hist_usage_data'].length === 0) return
    const minYear = activity['hist_usage_data'][0].year;
    const maxYear = activity['hist_usage_data'][activity['hist_usage_data'].length - 1].year;

    const years = [];
    for (let year = minYear; year <= maxYear; year++) {
        years.push(year);
    }

    const selected_activity_obj = []
    years.map((item, index) => {
        const existing_item = activity.hist_usage_data.find(k => k.year == item);
        if(existing_item){
            selected_activity_obj.push(existing_item)
        } else {
            selected_activity_obj.push( {year: item, primary: 0, secondary: 0})
        }
    })
    return {
      years,
      selected_activity_obj
    }
}
 
// Convert to hours and round to two decimal places
export function convertToHours(minutes) {
  if (!minutes) return minutes;
  const hours = minutes / 60;
  return parseFloat(hours.toFixed(2));
}

export const percentile = (arr: any[], q: number) => {
  if (!arr?.length) {
    return 0;
  }
  const filteredArray = arr.filter(
    (value) => value !== null || value !== undefined
  );
  const sorted = filteredArray.sort((a, b) => a - b);
  const pos = (sorted.length - 1) * q;
  const base = Math.floor(pos);

  const rest = pos - base;
  if (sorted[base + 1] !== undefined) {
    return (sorted[base] + rest * (sorted[base + 1] - sorted[base]))?.toFixed(2);
  }
  return sorted[base]?.toFixed(2);
};

export const getListBypropName = (array: any[], fieldName: string) => {
  return array?.map((item) => item[fieldName]);
};

export const sortList = (array: any[],order: string) => {
 return array.sort((a, b) => {
    if (order === 'asc') {
      return a - b;
    } else if (order === 'desc') {
      return b - a;
    }
    return 0
  });
 
}

export const  calculateMean = (array: any[]) => {
  if (array.length === 0) {
    return 0;
  }
  
  const sum = array.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  const mean = sum / array.length;
  
  return mean?.toFixed(2);
}

export const  formatCurrency = (value, locale = 'en-US', currency = 'USD') => {
  if(!value) {
    return ''
  }
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export const formatNumber = (value: number) => {
  if(value?.toString()?.includes('.')) {
    return value.toFixed(2);
  } 
  return value;
}

export const displayTimeInHoursOrMins = (time: number) => {
  if(time < 60)  {
    return formatNumber(time) + ' mins'
  } 
  return convertToHours(time) +' h'
}